/**
 * @namespace buy-carts-v2
 * @description Mapping of crc error codes for buy/carts/v2 using service error codes
 * @memberof ux-tread-crc-code
 *
 * @property {string} 400 - D4BAF0AF Bad Request
 * @property {string} 401 - A3BDC039 Unauthorized
 * @property {string} 404 - D3D734B6 Not Found
 * @property {string} 406 - 3DD9559A Not Acceptable
 * @property {string} 409 - AD66480B Conflict
 * @property {string} 500 - D5789A98 Internal Server Error
 * @property {string} 503 - 4C71CB22 Service Unavailable
 * @property {string} PRODUCT_NOT_BUYABLE - 3534E689 The item sku is not buyable, either due to sku was not found or is not valid for the country or not active, not being within sell dates, or launch product purchase being attempted outside of launch.
 * @property {string} ITEM_QUANTITY_LIMIT - ABB4C446 Quantity is more than the allowed quantity for the item sku.
 * @property {string} VALUE_ADDED_SERVICE_INVALID - B2D8D9B5 VAS associated with the item is invalid.
 * @property {string} VALUE_ADDED_SERVICE_SKU_COMBINATION_INVALID - 15E57A07 The items on the cart is not a VAS item.
 * @property {string} EXCLUSIVE_OFFER_INVALID - C4CD1584 OfferId used on the item is not valid.
 * @property {string} EXCLUSIVE_OFFER_PRODUCT_COMBINATION_INVALID - A954F3EE OfferId applied on on-exclusive access product.
 * @property {string} OUT_OF_STOCK - 7E977FCE Item does not have available inventory
 * @property {string} INVALID_GIFT_CARD_AMOUNT - 0E37BAB4 Gift Card does not have a valid price amount.
 * @property {string} PROMOTION_INVALID - 4CB0532B The promotion code is invalid
 * @property {string} PROMOTION_EXPIRED - AE66C4E0 The promotion code is expired
 * @property {string} INVALID_SWOOSH_QTY_LIMIT - 2DA19B6C Item quantity exceeds swoosh limit.
 * @property {string} INVALID_SWOOSH_PURCHASE_LIMIT - A553CABC Purchase amount exceeds swoosh limit.
 * @property {string} REQUEST_INVALID - 5ECAC143 Request was structurally invalid, such as malformed json.
 * @property {string} MISSING_REQUIRED - 197F50E6 A required field or fields in the request was missing. Examples include not providing cart ID, country, brand etc.
 * @property {string} FIELD_INVALID - 0BE59439 The value of a field or fields in the request was not valid. Examples include providing too many items, country code and/or brand not supported, etc.
 * @property {string} INVALID_QUANTITY - 23700428 The item total requested quantity was too high.
 * @property {string} INTERNAL_ERROR - 8BC1708E Error occurred while calling the exclusive access service for validating the offer.
 * @property {string} CART_COUNTRY_INVALID - 23A6EE7E Cart does not have valid country
 * @property {string} CART_CONFLICT - B63AF928 Cart id conflicts with an existing cart.
 * @property {string} COUNTRY_NOT_SUPPORTED - 840D5CFE Country not currently supported
 * @property {string} PRICE_CHANGED - D68D3EBF The price of an item or value added service has changed since the item was added to the cart.
 * @property {string} PROMOTION_NOT_APPLIED - A044DD39 The promotion code included was not applied on the order
 * @property {string} QUANTITY_MODIFIED - BB21138E The Line level quantity was modified to the quantity limits allowed for the given product Only if modifiers=VALIDATELIMITS
 * @property {string} PRODUCT_REMOVED - E0C22859 The product was not buyable/available adn the product was removed. Only if modifiers=VALIDATEAVAILABILITY
 */

module.exports = {
  400: 'D4BAF0AF',
  401: 'A3BDC039',
  404: 'D3D734B6',
  406: '3DD9559A',
  409: 'AD66480B',
  500: 'D5789A98',
  503: '4C71CB22',
  PRODUCT_NOT_BUYABLE: '3534E689',
  ITEM_QUANTITY_LIMIT: 'ABB4C446',
  VALUE_ADDED_SERVICE_INVALID: 'B2D8D9B5',
  VALUE_ADDED_SERVICE_SKU_COMBINATION_INVALID: '15E57A07',
  EXCLUSIVE_OFFER_INVALID: 'C4CD1584',
  EXCLUSIVE_OFFER_PRODUCT_COMBINATION_INVALID: 'A954F3EE',
  OUT_OF_STOCK: '7E977FCE',
  INVALID_GIFT_CARD_AMOUNT: '0E37BAB4',
  PROMOTION_INVALID: '4CB0532B',
  PROMOTION_EXPIRED: 'AE66C4E0',
  INVALID_SWOOSH_QTY_LIMIT: '2DA19B6C',
  INVALID_SWOOSH_PURCHASE_LIMIT: 'A553CABC',
  REQUEST_INVALID: '5ECAC143',
  MISSING_REQUIRED: '197F50E6',
  FIELD_INVALID: '0BE59439',
  INVALID_QUANTITY: '23700428',
  INTERNAL_ERROR: '8BC1708E',
  CART_COUNTRY_INVALID: '23A6EE7E',
  CART_CONFLICT: 'B63AF928',
  COUNTRY_NOT_SUPPORTED: '840D5CFE',
  PRICE_CHANGED: 'D68D3EBF',
  PROMOTION_NOT_APPLIED: 'A044DD39',
  QUANTITY_MODIFIED: 'BB21138E',
  PRODUCT_REMOVED: 'E0C22859',
};
